module.exports = __webpack_public_path__ + "static/media/1002253.74e3c6e3.png";